import { render } from "./answerList.vue?vue&type=template&id=4a15691b&scoped=true"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"

import "./answerList.vue?vue&type=style&index=0&id=4a15691b&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a15691b"]])

export default __exports__